import { guardNumber } from "../numbers";
import type { ArticleListItem, ArticleQuantityState, Nullable } from "../types";
import { gradeStockQuantity } from "./grade-stock-quantity";

/**
 * Grade an article against its own thresholds, on the quantity a new order could actually be
 * promised rather than on what happens to be standing on the shelf.
 *
 * `availableQuantity` is the physical balance less what orders still owing a pick have reserved,
 * so a full shelf whose every item is already claimed reads `empty` — which is the honest answer
 * to "can I have some", and the one the ordering screens need. The figure is allowed to be
 * negative when reservations already exceed the shelf, and that is `empty` too: there is nothing
 * to give, and how far past nothing it went is not a grade.
 */
export function getArticleQuantityState(
	articleListItem: Nullable<ArticleListItem>,
): ArticleQuantityState {
	if (!articleListItem) {
		return "empty";
	}
	return gradeStockQuantity(
		guardNumber(articleListItem.availableQuantity),
		guardNumber(articleListItem.warningStockBalance),
		guardNumber(articleListItem.minimumStockBalance),
	);
}
